import { useEffect, useState } from 'react';

/**
 * FIN-8016: tempo restante até a data limite, por diferença de relógio a cada
 * segundo e ao voltar a aba. Diferente do `utils/useTimer`, não atrasa com a
 * aba em segundo plano. `null` no SSR, sem prazo ou com prazo inválido.
 */
export function useDeadlineCountdown(
  availableUntil: string | null | undefined
): { remainingMs: number | null } {
  const [remainingMs, setRemainingMs] = useState<number | null>(null);

  useEffect(() => {
    const deadlineMs = availableUntil ? Date.parse(availableUntil) : NaN;

    if (Number.isNaN(deadlineMs)) {
      setRemainingMs(null);
      return undefined;
    }

    let intervalId: ReturnType<typeof setInterval> | undefined;

    const tick = () => {
      const remaining = Math.max(0, deadlineMs - Date.now());
      setRemainingMs(remaining);

      if (remaining === 0 && intervalId !== undefined) {
        clearInterval(intervalId);
        intervalId = undefined;
      }
    };

    const onVisibilityChange = () => {
      if (document.visibilityState === 'visible') tick();
    };

    tick();
    if (deadlineMs > Date.now()) {
      intervalId = setInterval(tick, 1000);
    }
    document.addEventListener('visibilitychange', onVisibilityChange);

    return () => {
      if (intervalId !== undefined) clearInterval(intervalId);
      document.removeEventListener('visibilitychange', onVisibilityChange);
    };
  }, [availableUntil]);

  return { remainingMs };
}
